import { handleActions } from 'redux-actions';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import {
  GO_TO_STEP,
  SET_ATTR_GROUPS,
  SET_ATTR_ERRORS,
  SET_FORM_ERRORS,
  SET_STEPS,
  RESET_TARGET_STEP,
  RESET,
} from './actions';

const initialState = {
  steps: [],
  currentStepIdx: 0,
  targetStepIdx: 0,
  formErrors: {},
  attrErrors: {},
  attrGroups: [],
};

export default handleActions(
  {
    [SET_STEPS]: (state, { payload }) => ({
      ...state,
      steps: payload,
    }),
    [SET_ATTR_GROUPS]: (state, { payload }) => ({
      ...state,
      attrGroups: payload,
    }),
    [GO_TO_STEP]: (state, { payload: stepIdx }) => {
      const stepsToValidate = state.steps.slice(0, stepIdx);

      return {
        ...state,
        currentStepIdx: getLastValidStepIdx(stepsToValidate, state.formErrors, state.attrErrors, state.attrGroups) + 1,
        targetStepIdx: stepIdx,
      };
    },
    [RESET_TARGET_STEP]: state => ({
      ...state,
      targetStepIdx: state.currentStepIdx,
    }),
    [SET_ATTR_ERRORS]: (state, action) => {
      if (isEqual(state.attrErrors, action.payload)) {
        return state;
      }
      return {
        ...state,
        attrErrors: action.payload,
      };
    },
    [SET_FORM_ERRORS]: (state, action) => {
      if (isEqual(state.formErrors[action.payload.step], action.payload.errors)) {
        return state;
      }
      return {
        ...state,
        formErrors: {
          ...state.formErrors,
          [action.payload.step]: action.payload.errors,
        },
      };
    },
    [RESET]: state => ({
      ...state,
      ...initialState,
    }),
  },
  initialState
);

function getLastValidStepIdx(steps, formErrors, attrsErrors, groupedAttributes) {
  let idx = 0;
  while (steps[idx] && isStepValid(steps[idx], formErrors, attrsErrors, groupedAttributes)) {
    idx++;
  }

  return idx - 1;
}

function isStepValid(stepId, formErrors, attrsErrors, groupedAttributes) {
  switch (stepId) {
    case 'basic':
      return isEmpty(formErrors['basic']) && !hasAttrGroupError(attrsErrors, groupedAttributes[0]);
    case 'description':
      return isEmpty(formErrors['description']);
    case 'seo':
      return isEmpty(formErrors['seo']);
  }
  const group = groupedAttributes.find(({ id }) => stepId === id);

  if (!group) {
    return true;
  }
  const nextGroup = groupedAttributes[groupedAttributes.indexOf(group) + 1];

  return !hasAttrGroupError(attrsErrors, group) && !hasAttrGroupError(attrsErrors, nextGroup);
}

function hasAttrGroupError(errorMap, group) {
  if (!group) {
    return false;
  }
  const attrIds = group.attributes.map(attr => attr.id);

  return errorMap ? Object.keys(errorMap).some(attrIdWithError => attrIds.includes(attrIdWithError)) : false;
}
